(function () {
  var root = document.getElementById('riwayat-oil-border');
  if (!root) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var current = 0;
  var target = 0;
  var ticking = false;

  function computeProgress() {
    var doc = document.documentElement;
    var scrollable = doc.scrollHeight - window.innerHeight;
    if (scrollable <= 0) return 0;
    var raw = window.scrollY / scrollable;
    return Math.max(0, Math.min(1, raw));
  }

  function tick() {
    ticking = false;
    var lerp = reducedMotion ? 1 : 0.12;
    current += (target - current) * lerp;
    if (Math.abs(target - current) < 0.001) current = target;
    root.style.setProperty('--riwayat-oil-progress', current.toFixed(4));
    if (current !== target) requestAnimationFrame(tick);
  }

  function onScroll() {
    target = computeProgress();
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(tick);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();
})();
